// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lOzF4n78HypYqbq7k0Yl {
  margin-top: auto;
  background-color: var(--header-menu-content-footer);
  padding: 2rem 2rem 3rem 2rem;
}

.n7oRWZRN2x9Drcckq74h {
  width: auto;
  height: auto;
}

.XrV1j_mvRTPBNraj_wFU {
  cursor: pointer;
}

.bJc4CRvGMdY5P8jg0sTC {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.75rem;
}

@media only screen and
  (max-width: 639px) {
  .lOzF4n78HypYqbq7k0Yl {
    padding: 2rem 1rem 3rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderMenuContentFooter/HeaderMenuContentFooter.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAW;EACX,cAAY;EACZ,qBAAkB;AACpB;;AAEA;;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".headerMenuContentFooter {\n  margin-top: auto;\n  background-color: var(--header-menu-content-footer);\n  padding: 32px 32px 48px 32px;\n}\n\n.flagIcon {\n  width: auto;\n  height: auto;\n}\n\n.itemContentFlag {\n  cursor: pointer;\n}\n\n.itemIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n\n@media (--mobile) {\n  .headerMenuContentFooter {\n    padding: 32px 16px 48px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMenuContentFooter": `lOzF4n78HypYqbq7k0Yl`,
	"flagIcon": `n7oRWZRN2x9Drcckq74h`,
	"itemContentFlag": `XrV1j_mvRTPBNraj_wFU`,
	"itemIcon": `bJc4CRvGMdY5P8jg0sTC`
};
export default ___CSS_LOADER_EXPORT___;
